"use client";

import * as React from "react";
import { createPortal } from "react-dom";
import { useArticleShellSlots } from "@/components/article-shell/ArticleShellContext";
import { useSubjectIndexMobileTopics } from "@/components/SubjectIndexMobileTools";

/**
 * 카테고리 인덱스 페이지의 주요항목(MajorTopics)을 3컬럼 셸 좌측 사이드바로 옮기는 래퍼 (JCG-2098).
 *
 * - 셸(데스크탑 카테고리 인덱스): 셸이 좌측 사이드바에 둔 subjectSlot 으로 children 을 createPortal.
 *   슬롯이 아직 준비되지 않은 첫 렌더에는 렌더를 보류해(본문 깜빡임 방지) 슬롯 마운트 후 그린다.
 * - 셸 밖(모바일/클래식 레이아웃): 모바일 하단 도구 Provider 가 있으면 children 을 주요항목 뷰에
 *   등록하고, 인라인 렌더는 하지 않는다(클래식 전 구간 <1024px 에서 Dock '주요항목' 뷰가 대신).
 *
 * children 은 서버 컴포넌트(MajorTopics)여도 안전하다 — 서버 페이지가 렌더한 ReactNode 를 그대로
 * portal/뷰에 전달하므로, async 서버 컴포넌트를 클라이언트에서 직접 렌더하는 제약을 받지 않는다.
 */
export default function SubjectSidebarPortal({
  children,
}: {
  children: React.ReactNode;
}) {
  const { inShell, subjectSlot } = useArticleShellSlots();
  const hasMobileTools = useSubjectIndexMobileTopics(children, !inShell);

  if (inShell) {
    return subjectSlot ? createPortal(children, subjectSlot) : null;
  }

  if (hasMobileTools) {
    // 모바일 하단 도구가 있으면 주요항목은 Dock '주요항목' 뷰로 제공된다
    // (클래식 전 구간 <1024px, 인라인 중복 렌더 방지).
    return null;
  }

  return <>{children}</>;
}
